module.exports = __webpack_public_path__ + "media/components/assets/img/logo/wizzair-16401dba639b3a744c444f1a26a46098.svg";